import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function CheckmarkIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'AccentGreen', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    return (_jsx("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: _jsx("path", { d: "M2 13.083L4 11l4.667 3.75L20 6l2 2.083-13.333 12.5L2 13.083z", fill: primaryFillColor }) }));
}
//# sourceMappingURL=Checkmark.js.map